/* Scroll reveal for animated elements */
(function () {
  'use strict';
  var els = document.querySelectorAll('.sc-origin__card, .sc-handcraft, .sc-puglia-video');
  var natureNotes = document.querySelectorAll('.sc-nature-notes');
  var manifestoSections = document.querySelectorAll('.sc-pdp-manifesto');
  var signatureSections = document.querySelectorAll('.sc-home-terra, .sc-home-trullo, .sc-home-gold');
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /*
   * Homepage motion language — three levels.
   *
   * 1. Products (rails, prices, cards) never animate: they are visible at once.
   * 2. Editorial copy and media fade in softly, triggered before they reach the
   *    viewport so the movement is almost over when the reader arrives.
   * 3. Terra, Trullo and Gold are signature moments: their composition is shown
   *    in its final state and only the photographs breathe in (fade + slow
   *    zoom-out), with no lateral slides or rotations.
   *
   * Sections stay visible until this script runs, so a slow or failed script can
   * never leave content hidden.
   */
  var homeMotionSections = [];
  var homeMotionConfigs = [
    ['.sc-collection-triad', '.sc-collection-triad__intro, .sc-collection-triad__card'],
    ['.sc-origin-intro', '.sc-origin-intro__heading, .sc-origin-intro__link'],
    ['.sc-emotion-panel', '.sc-emotion-panel__copy, .sc-emotion-panel__thumbs, .sc-emotion-panel__film > figure'],
    ['.sc-bestsellers', '.sc-bestsellers__intro'],
    ['.sc-gift-budget', '.sc-gift-budget__intro'],
    ['.sc-doors', '.sc-doors__intro, .sc-door'],
    ['.sc-process-belief', ':scope > figure, .sc-process-belief__copy'],
    ['.sc-fullbleed-video', ':scope > img, :scope > div'],
    ['.sc-social-gallery', ':scope > .sc-kicker, .sc-social-gallery__rail > img'],
    ['.sc-home-wholesale', '.sc-home-wholesale__eyebrow, h2, .sc-home-wholesale__aside'],
    ['.sc-final-home', '.sc-editorial-newsletter, .sc-final-signature']
  ];

  homeMotionConfigs.forEach(function (config) {
    document.querySelectorAll(config[0]).forEach(function (section) {
      var items = section.querySelectorAll(config[1]);
      if (!items.length) return;

      section.classList.add('sc-motion-section');
      items.forEach(function (item, index) {
        item.classList.add('sc-motion-item');
        item.style.setProperty('--sc-motion-order', Math.min(index, 3));
      });
      homeMotionSections.push(section);
    });
  });

  // Signature sections always render their final composition.
  signatureSections.forEach(function (section) { section.classList.add('is-visible'); });

  function isBelowFold(element) {
    return element.getBoundingClientRect().top > window.innerHeight;
  }

  // On desktop the theme scrolls inside .page-wrapper, not the window: observe
  // against it so the early-start margin is not clipped away.
  function scrollRoot() {
    var wrapper = document.querySelector('.page-wrapper');
    if (!wrapper) return null;
    return /(auto|scroll)/.test(window.getComputedStyle(wrapper).overflowY) ? wrapper : null;
  }

  if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
    els.forEach(function (c) { c.classList.add('is-visible'); });
    natureNotes.forEach(function (section) { section.classList.add('is-visible'); });
    manifestoSections.forEach(function (section) { section.classList.add('is-visible'); });
    homeMotionSections.forEach(function (section) { section.classList.add('is-visible'); });
  } else {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (c) { obs.observe(c); });
    natureNotes.forEach(function (section) {
      section.classList.add('sc-reveal-ready');
      obs.observe(section);
    });
    manifestoSections.forEach(function (section) {
      section.classList.add('sc-reveal-ready');
      obs.observe(section);
    });

    // Home motion starts slightly before the section enters the viewport.
    var motionObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var section = e.target;
        motionObs.unobserve(section);
        if (!section.classList.contains('sc-calm-section')) {
          section.classList.add('is-visible');
          return;
        }
        section.classList.add('sc-calm-in');
        // Hand the photographs back to their own hover transitions once settled.
        window.setTimeout(function () {
          section.classList.remove('sc-calm-section', 'sc-calm-in');
        }, 1800);
      });
    }, { root: scrollRoot(), threshold: 0, rootMargin: '0px 0px 12% 0px' });

    homeMotionSections.forEach(function (section) {
      if (!isBelowFold(section)) {
        section.classList.add('is-visible');
        return;
      }
      section.classList.add('sc-motion-ready');
      motionObs.observe(section);
    });

    signatureSections.forEach(function (section) {
      if (!isBelowFold(section)) return;
      section.classList.add('sc-calm-section');
      motionObs.observe(section);
    });
  }

  var originRail = document.querySelector('.sc-genesis-strip .sc-product-strip__rail') || document.querySelector('.sc-product-strip .sc-product-strip__rail');
  var originControls = document.querySelector('.sc-origin-intro__controls');
  if (originRail && originRail.closest('.sc-pdp-recommendations')) originRail = null;
  if (originControls && originControls.closest('.sc-pdp-recommendations')) originControls = null;
  if (originRail && originControls) {
    var previousButton = originControls.querySelector('[data-sc-origin-scroll="previous"]');
    var nextButton = originControls.querySelector('[data-sc-origin-scroll="next"]');
    var scrollFrame = null;
    var edgeTolerance = 32;
    originRail.id = originRail.id || 'sc-origin-product-rail';
    previousButton.setAttribute('aria-controls', originRail.id);
    nextButton.setAttribute('aria-controls', originRail.id);

    function updateOriginControls() {
      var maxScrollLeft = Math.max(0, originRail.scrollWidth - originRail.clientWidth);
      var scrollLeft = originRail.scrollLeft;
      previousButton.disabled = scrollLeft <= edgeTolerance;
      nextButton.disabled = scrollLeft >= maxScrollLeft - edgeTolerance;
    }

    function originScrollStep() {
      var card = originRail.querySelector('.sc-product-card');
      if (!card) return originRail.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(originRail).gap) || 0;
      var cardsPerStep = window.matchMedia('(min-width: 990px)').matches ? 2 : 1;
      return (card.getBoundingClientRect().width + gap) * cardsPerStep;
    }

    originControls.addEventListener('click', function (event) {
      var button = event.target.closest('[data-sc-origin-scroll]');
      if (!button || button.disabled) return;
      var direction = button.dataset.scOriginScroll === 'previous' ? -1 : 1;
      var maxScrollLeft = Math.max(0, originRail.scrollWidth - originRail.clientWidth);
      var targetScrollLeft = Math.min(maxScrollLeft, Math.max(0, originRail.scrollLeft + direction * originScrollStep()));
      originRail.scrollTo({
        left: targetScrollLeft,
        behavior: prefersReducedMotion.matches ? 'auto' : 'smooth'
      });
    });

    function scheduleOriginControls() {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function () {
        updateOriginControls();
        scrollFrame = null;
      });
    }
    originRail.addEventListener('scroll', scheduleOriginControls, { passive: true });
    window.addEventListener('resize', scheduleOriginControls, { passive: true });
    scheduleOriginControls();
  }
})();
